import requestStatuses from '@clearscore/constants.request-statuses';

import { getTypes } from './types';

export default (TYPE) => {
    const TYPES = getTypes(TYPE);
    const initialState = {
        status: requestStatuses.INITIAL,
    };
    return (state = initialState, action = {}) => {
        const { payload = {}, type = '' } = action;
        switch (type) {
            case TYPES.pending:
                return {
                    ...state,
                    status: requestStatuses.PENDING,
                    statusCode: undefined,
                    request: action.requestData,
                    meta: payload?.request?.meta,
                };
            case TYPES.success:
                return {
                    ...state,
                    status: requestStatuses.SUCCESS,
                    data: payload?.data || payload,
                    statusCode: action.statusCode,
                    request: action.requestData,
                    meta: action.requestMeta,
                };
            case TYPES.error:
                return {
                    ...state,
                    status: requestStatuses.ERROR,
                    data: payload?.data || payload,
                    statusCode: action.statusCode || payload?.status,
                    request: action.requestData,
                    meta: action.requestMeta,
                };
            case TYPES.reset:
                return {
                    ...state,
                    status: requestStatuses.INITIAL,
                    statusCode: undefined,
                    request: undefined,
                    meta: undefined,
                };
            default:
                return state;
        }
    };
};
